import { css } from 'styled-components';

export const verticalScrollBar = (thumbColor: string) => css`
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${thumbColor};
    border-radius: 6px;
  }
`;
